export interface Folder {
  id: number;
  correlative_id: number;
  documents?: any[];
  documents_attributes?: any[];
  extra_params: FolderExtraParams;
  status: string;
  type: string;
}

interface FolderExtraParams {
  documents_count: number;
  provider_ids: number[];
  provider_names: string;
  required_products: any[];
  warehouse_id: number;
  warehouse_name: string;
}

export enum Status {
  pending = 'Pendiente',
  in_progress = 'En progreso',
  closed = 'Cerrada',
}

export enum StatusColor {
  pending = '#ECB818',
  in_progress = 'blue',
  closed = '#32C232',
}
